import { UserRoleEnum } from "../../generated/graphql";

export const TABLE_HEADER = ["Фамилия", "Имя", "Номер телефона", "Страна", "Доступ"];
export const USER_ROLES = [
  { role: UserRoleEnum.Teacher, name: "Учитель" },
  { role: UserRoleEnum.Pupil, name: "Ученик" },
  { role: UserRoleEnum.Parent, name: "Родитель" },
];
